import React, { useState, useEffect } from "react";
import {
    Modal,
    Button,
    Form,
    FormGroup,
    FormControl,
    ControlLabel,
    Row,
    Col,
} from "react-bootstrap";
// import * as API from "../../../api/emr";
import './style.css'
import * as API from '../../../api/billing'
import { useSelector, useDispatch } from "react-redux";
import * as actionTypes from "Front/actions/actionTypes";

const AddEditBillCategoryModal = ({ show, onHide, row = {}, isCategoryAddedFromAddOnService, onAddCategory }) => {
    const [formData, setFormData] = useState({ name: "", description: "" });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [id, setBillCategoryId] = useState("");
    const [nameAlreadyExist, setBillCategoryAlreadyExist] = useState(false);
    const [nameAlreadyExistMsg, setBillCategoryAlreadyExistMsg] = useState("");
    const [mode, setMode] = useState("add")
    const billingReduxData = useSelector((store) => store.billing);
    const dispatch = useDispatch()

    useEffect(() => {
        if (row?._id) {
            setFormData({ name: row.name || "", description: row.description || "" });
            setBillCategoryId(row._id);
            setMode('edit')
        }
    }, [row]);

    const inputHandler = (e) => {
        const { name, value } = e.target;
        const cleanedValue = value.replace(/\s+/g, " ").trimStart();
        setFormData({ ...formData, [name]: cleanedValue });
        validate();
    };

    const validate = () => {
        const err = {};
        let isValid = true;

        if (!formData.name || formData.name.trim() === "") {
            err.name = "error";
            isValid = false;
        }

        setErrors(err);
        if (!isValid)
            setIsLoading(false)
        return isValid;
    };

    const submitHandler = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (validate()) {
            let resp;
            try {
                const sentData = new FormData();
                sentData.append("name", formData.name);
                sentData.append("description", formData.description || "")


                if (mode === "add") {
                    resp = await API.addBillCategory(sentData);
                } else {
                    sentData.append("id", id);
                    resp = await API.updateBillCategory(sentData);
                }

                setIsLoading(false);

                if (resp?.data?.statusCode === 200 && resp.data.status === "Success") {
                    if (isCategoryAddedFromAddOnService) {
                        const newCategory = { _id: resp?.data?.data?.id, name: formData?.name }
                        onAddCategory(newCategory)
                    }
                    if (mode === "edit") {
                        const allCategories = billingReduxData?.billCategoryList
                        if (allCategories?.length) {
                            const updatedCategories = allCategories.map(cat => {
                                if (cat?._id === id) {
                                    return {
                                        ...cat,
                                        name: formData.name,
                                        description: formData.description,
                                    };
                                }
                                return cat;
                            });
                            dispatch({
                                type: actionTypes.SET_ALL_BILL_CATEGORY_LIST,
                                payload: updatedCategories,
                            });
                        }
                    } else if (mode === "add") {
                        const allCategories = billingReduxData?.billCategoryList || [];
                        const createdCategory = {
                            _id: resp?.data?.data?.id,
                            name: formData.name,
                            description: formData.description || "",
                            isActive: true,
                            clinicId: localStorage.getItem("clinicId"),
                            systemDefault: false,
                            systemDefaultName: ""
                        };
                        dispatch({
                            type: actionTypes.SET_ALL_BILL_CATEGORY_LIST,
                            payload: [...allCategories, createdCategory],
                        });
                    }
                    onHide(true);
                }

            } catch (error) {
                const errorMsg =
                    error?.response?.data?.msg || "Something went wrong while updating the category.";
                setBillCategoryAlreadyExist(true);
                setBillCategoryAlreadyExistMsg(errorMsg);
            } finally {
                setIsLoading(false);
            }
        }
    };

    console.log(row, "--------row")
    return (
        <Modal
            show={show}
            onHide={onHide}
            dialogClassName="modal-md modal-dialog-centered"
        >
            <Modal.Header closeButton className="bg-thumbcolor">
                <Modal.Title id="example-modal-sizes-title-lg">
                    {mode === "add" ? "Add" : "Edit"} Category</Modal.Title>
            </Modal.Header>
            <Modal.Body className="body-parts">
                <Form horizontal>
                    <FormGroup>
                        <Col sm={12}>
                            <FormControl
                                type="text"
                                name="name"
                                placeholder="Category"
                                autoComplete="off"
                                value={formData.name || ""}
                                onChange={inputHandler}
                                className={`insulin-input ${errors.name || ""}`}
                            />
                            {nameAlreadyExist && (
                                <span className="star">{nameAlreadyExistMsg}</span>
                            )}
                        </Col>
                    </FormGroup>
                    <FormControl
                        as="textarea"
                        rows={4} // Optional: number of visible rows
                        name="description"
                        placeholder="description"
                        autoComplete="off"
                        value={formData.description}
                        onChange={inputHandler}
                        className={`form-control mb-2 ${errors.description || ""}`}
                        style={{ marginBottom: "10px" }}
                    />
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    style={{ float: "right", borderRadius: "5px" }}
                    className="btn-fill btn-primary"
                    onClick={submitHandler}
                    disabled={isLoading || errors?.length}
                >
                    {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Save"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddEditBillCategoryModal;
